import { secondaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, breakpoints, sizes } = redesignTheme;

export const minorTestShellStyles = {
  page: {
    minHeight: '100vh',
    backgroundColor: colors.background,
    color: colors.primaryDark,
    fontFamily: fonts.opensans,
  },
  logoButton: {
    border: 0,
    padding: 0,
    background: 'transparent',
    cursor: 'pointer',
    flexShrink: 0,
  },
  logo: {
    display: 'block',
    width: sizes.logoWidth,
    height: sizes.logoHeight,
    maxWidth: '40vw',
    objectFit: 'contain',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: 160,
      height: 'auto',
    },
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: spacing.md,
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      display: 'none',
    },
  },
  phoneBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  phoneLine: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    fontSize: fontSize.md,
    fontFamily: fonts.opensansSemiBold,
    letterSpacing: 0.28,
  },
  phoneNote: {
    margin: 0,
    fontSize: 8,
    letterSpacing: 0.16,
  },
  button: {
    ...secondaryButtonStyle,
    textTransform: 'none',
  },
} as const;
